var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.42117e-05 5.96504C-0.0186758 6.27441 0.215699 6.5416 0.527418 6.5627C0.839137 6.58379 1.10398 6.34707 1.12507 6.03535L1.13679 5.84785C1.21648 4.56348 2.28054 3.5627 3.56726 3.5627H8.58054L7.29148 4.85176C7.07117 5.07207 7.07117 5.42832 7.29148 5.64629C7.51179 5.86426 7.86804 5.8666 8.08601 5.64629L10.336 3.39629C10.5563 3.17598 10.5563 2.81973 10.336 2.60176L8.08601 0.351758C7.8657 0.131445 7.50945 0.131445 7.29148 0.351758C7.07351 0.57207 7.07117 0.92832 7.29148 1.14629L8.58054 2.43535H3.56726C1.68757 2.4377 0.131324 3.9002 0.011793 5.77754L7.42117e-05 5.96504ZM11.9977 6.03535C12.0165 5.72598 11.7821 5.45879 11.4704 5.4377C11.1587 5.4166 10.8938 5.65332 10.8751 5.96504L10.8634 6.15254C10.7837 7.43691 9.71726 8.4377 8.43054 8.4377H3.41961L4.70867 7.14863C4.92898 6.92832 4.92898 6.57207 4.70867 6.3541C4.48836 6.13613 4.13211 6.13379 3.91414 6.3541L1.66414 8.60176C1.44382 8.82207 1.44382 9.17832 1.66414 9.39629L3.91414 11.6463C4.13445 11.8666 4.4907 11.8666 4.70867 11.6463C4.92664 11.426 4.92898 11.0697 4.70867 10.8518L3.41961 9.5627H8.43289C10.3149 9.5627 11.8712 8.10019 11.9884 6.22285L12.0001 6.03535H11.9977Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplace);
export default __webpack_public_path__ + "static/media/replace.84dd78d048dbdf15861da64594691c07.svg";
export { ForwardRef as ReactComponent };